import { useState, useEffect } from 'react'
import './Pages.css'
import './Schedule.css'

function Schedule() {
    const [events, setEvents] = useState([])

    useEffect(() => {
        fetch('/data/schedule.json')
            .then(res => res.json())
            .then(setEvents)
    }, [])

    const today = new Date().toISOString().split('T')[0]
    const upcoming = events
        .filter(e => e.date >= today)
        .sort((a,b) => a.date.localeCompare(b.date))
    const recent = events
        .filter(e => e.date < today)
        .sort((a,b) => b.date.localeCompare(a.date))

    function formatDate(dateStr) {
        const [year, month, day] = dateStr.split('-')
        return new Date(year, month - 1, day).toLocaleDateString('en-US', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        })
    }

    function renderEvent(event) {
        const locationParts = event.location.split(',').map(s => s.trim())
        const addressParts = event.address.split(',')
        const street = addressParts[0].trim()
        const cityStateZip = addressParts.slice(1).join(',').trim()

        return (
            <div className="schedule-card" key={event.date + event.name}>
                <div className="schedule-left">
                    <div className="schedule-date">{formatDate(event.date)}</div>
                    <p className="schedule-time">{event.time}</p>
                    <p className="schedule-price">{event.price}</p>
                </div>
                <div className="schedule-details">
                    <h3 className="schedule-name">{event.name}</h3>
                    <p className="schedule-info">{locationParts[0]}</p>
                    {locationParts[1] && <p className="schedule-info">{locationParts[1]}</p>}
                    <p className="schedule-info">{street}</p>
                    <p className="schedule-info">{cityStateZip}</p>
                </div>
            </div>
        )
    }

    return (
        <div className="page">
            <h1>Upcoming</h1>
            {upcoming.length >0 
                ? upcoming.map(renderEvent)
                : <p>More events coming soon!</p>
            }

            {recent.length > 0 && (
                <>
                    <h1 className="schedule-section-heading">Recent</h1>
                    {recent.map(renderEvent)}
                </>
            )}
        </div>
    );
}

export default Schedule; 